import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { NgIf, NgFor } from "@angular/common";

@Component({
    selector: 'app-gender-filter-block',
    templateUrl: './genderFilterBlock.component.html',
    styleUrls: ['./genderFilterBlock.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, FormsModule, TranslateModule]
})

export class GenderFilterBlockComponent{
    isDisplayed:boolean = false;
    genders: string[] = ['all', 'man', 'woman'];
    @Input() genderSelected:string;

    toggleVisibility(){
        this.isDisplayed = !this.isDisplayed;
    }
    
    hide(){
        if(this.isDisplayed) this.isDisplayed = false;
    }
    
    show(){
        if(!this.isDisplayed) this.isDisplayed = true;
    }
    
}